export default "__VITE_ASSET__BK_XS6GI__"